<li class="nav-item me-2">
  <button *ngIf="enableDeleteButton" (click)="deleteTurn()" class="btn btn-danger"><i class="fa fa-times" aria-hidden="true"></i> {{ "delete" | language }}</button>
</li>
